<template>
  <div class="modal-content">
    <div class="absolute right-6 mt-4 flex items-center focus:outline-none z-10" @click="clearForm">
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/></svg>
    </div>
    <input id="searchStation" @input="updateText($event.target.value)" class="input-station" :placeholder="$t('tour_require_station')" v-model="textbox" />
    <div v-if="stations.length > 0 && name.length > 0">
      <div
        v-for="(station, index) in stations"
        v-bind:key="index"
        v-on:click="setStation(station)"
        class="station-name">
        {{ station.Name }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    callback: {
      type: Function,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      textbox: '',
      name: "",
      oldInput: ""
    }
  },
  created: function () {
    setInterval(()=>{
      if(this.oldInput !== this.name && this.name.length > 0){
        this.oldInput = this.name
        this.$store.dispatch('stations/search', this.name)
      }
    }, 300)
  },
  computed: {
    ...mapGetters({
      stations: 'stations/getStations'
    })
  },
  methods: {
    setStation: function (station) {
      this.textbox = station.Name
      this.callback(station)
    },
    updateText: function (name) {
      this.name = name
    },
    clearForm: function () {
      this.textbox = ''
    }
  }
}
</script>
